import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { KeyboardPluginInterface } from './definitions';
import { CAPACITOR_MN_KEYBOARD_PLUGIN } from '../pluginConstants';

const KeyboardPluginRaw = registerPlugin<KeyboardPluginInterface>(CAPACITOR_MN_KEYBOARD_PLUGIN);
// Wrapped to ensure rejected bridge calls retain a call-site stack trace.
const KeyboardPlugin = withBridgedStackTrace(KeyboardPluginRaw, CAPACITOR_MN_KEYBOARD_PLUGIN);

export * from './definitions';
export { KeyboardPlugin };
